import isEmpty from "lodash/isEmpty"

export const parseDataStatusMessageShow = (data) => {
  const parsedRequest = {
    id: data.id,
    name: data.name,
    components: data.components,
    message: data.message,
    effectiveFrom: data.effectiveFrom,
    effectiveTo: data.effectiveTo,
    type: data.type,
    deleted: data.deleted,
  };

  return parsedRequest;
};

export const parseDataStatusMessageList = (data) => {
  const parsedRequest = {
    id: data.id,
    name: data.name,
    components: data.components,
    message: data.message,
    effectiveFrom: data.effectiveFrom,
    effectiveTo: data.effectiveTo,
    type: data.type,
    deleted: data.deleted,
  };

  return parsedRequest;
};

export const parseDataStatusMessageCreate = (data) => {
  const parsedRequest = {
    name: data.name,
    components: data.components,
    message: data.message,
    effectiveFrom: new Date(data.effectiveFrom).toISOString(),
    effectiveTo: new Date(data.effectiveTo).toISOString(),
    type: data.type,
    deleted: data.deleted,
  };

  return JSON.stringify(parsedRequest);
};

export const parseDataStatusMessageUpdate = (data) => {
  const parsedRequest = {
    id: data.id,
    name: data.name,
    components: data.components,
    message: data.message,
    effectiveFrom: new Date(data.effectiveFrom).toISOString(),
    effectiveTo: new Date(data.effectiveTo).toISOString(),
    type: data.type,
    deleted: data.deleted,
  };
  return JSON.stringify(parsedRequest);
};

export const parseLabelColor = (data) => {
  return (data === 'danger') ? 'error' : data
}

export function parseActiveStatusMessages(data) {
  if (!isEmpty(data)) {
    return data.map((message) => {
      if (message.type === "danger") {
        message.type = "error";
      }

      delete message["displayName"];
      delete message["effectiveFrom"];
      delete message["effectiveTo"];
      delete message["components"];
      delete message["deleted"];

      return message;
    });
  }
}
